import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryAgencies } from "@/strapiQuery/agencies";
import { AgenciesContent } from "@/components/pages/agencies/Agencies";
import { DepartmentDetails } from "@/interfaces/departmentDetails";
import { NetworkError } from "@/interfaces/errors/networkError";
import { page404 } from "@/const/page404";
import { sendFetchRequest } from "@/utils/sendFetchRequest";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  let departments: DepartmentDetails[];
  try {
    departments = await sendFetchRequest("/states/v1").then(
      (json: DepartmentDetails[]) => json
    );
  } catch (error) {
    if (error instanceof NetworkError) {
      return page404;
    }
    throw error;
  }

  const agenciesContentPromise = getStrapiEntity<AgenciesContent>(
    "agency",
    queryAgencies,
    "en"
  );

  const [layout, agenciesContent] = await Promise.all([
    layoutPromise,
    agenciesContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      reviewsConst,
      departments,
      ...agenciesContent,
      intlMessages,
      defaultCanonicalRoute: routes.agencies,
    },
    revalidate: 10,
  };
};

export { Agencies as default } from "@/components/pages/agencies/Agencies";
